export const enum RenderingMode {
    MODE_QUESTION = 1,
    MODE_ANSWER = 2,
    MODE_PREVIEW = 3,
    MODE_EXAM_MARKING = 4,
    MODE_IN_REVIEW = 5,
    MODE_QUESTION_ONLY = 6,
    MODE_ANSWER_ONLY = 7,
}
